module.exports = __webpack_public_path__ + "img/zsk (4).7c20e584.jpg";